var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Umsatz: Wochentag × Uhrzeit"}},[_c('vue-apex-charts',{attrs:{"type":"heatmap","height":"320","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }